import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { getStudents } from "../controllers/studentController";
import { getStudentErrorMessage, normalizeStudentListResponse } from "../utils/studentUtils";
import { getLmsRole } from "../../utils/lmsRole";
import StudentCard from "../components/StudentCard";
import StudentsEmptyState from "../components/StudentsEmptyState";
import { StudentsWrapper } from "../styles/StudentsStyle";

const StudentsPage = () => {
  const [students, setStudents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const { credObj } = useSelector((store) => store.auth);
  const { currentUser } = useSelector((store) => store.users);
  const role = getLmsRole({ currentUser, credObj });

  useEffect(() => {
    let isMounted = true;

    const loadStudents = async () => {
      setIsLoading(true);
      setError("");
      try {
        const response = await getStudents();
        if (isMounted) {
          setStudents(normalizeStudentListResponse(response));
        }
      } catch (err) {
        if (isMounted) setError(getStudentErrorMessage(err.message));
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    loadStudents();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <StudentsWrapper>
      <section className="students-header">
        <div>
          <p className="eyebrow">{role === "parent" ? "My Kids" : "Students"}</p>
          <h1>{role === "parent" ? "Guide your kids' reading growth" : "Guide every student's reading growth"}</h1>
          <p>Create learner profiles, share credentials, and keep reading progress moving.</p>
        </div>
        <Link to="/dashboard/students/new" className="lms-primary-action">
          {role === "parent" ? "Create Kid" : "Create Student"}
        </Link>
      </section>

      {error && <p className="students-error" role="alert">{error}</p>}
      {isLoading && <p className="students-loading">Loading students...</p>}

      {!isLoading && !error && students.length === 0 && <StudentsEmptyState role={role} />}

      {!isLoading && !error && students.length > 0 && (
        <section className="students-grid" aria-label="Student list">
          {students.map((student) => (
            <StudentCard key={student.id} student={student} />
          ))}
        </section>
      )}
    </StudentsWrapper>
  );
};

export default StudentsPage;
